export const hiddenDots = '••••••••••';
export const hiddenDate = '••/••/••••';
export const hiddenTime = '••:••';

export const hiddenFormInput = {
  label: hiddenDots,
  value: hiddenDots,
};
